var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-small",
              on: { click: _vm.toPrint }
            },
            [_vm._v("打印")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("报废单信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showScrapVoucherInfoFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowScrapVoucherInfo()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showScrapVoucherInfoFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showScrapVoucherInfoFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showScrapVoucherInfoFlag
        ? [
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.scrapVoucherInfo.innerNo || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.scrapVoucherInfo.reservedNo || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.scrapVoucherInfo.totalQuantity || 0))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.scrapVoucherInfo.splittedAmount || 0.0) + " 元"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.scrapVoucherInfo.applicantName))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.scrapVoucherInfo.applicantContactTel))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.scrapVoucherInfo.retailerRealComName))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.scrapVoucherInfo.comFullName))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.scrapVoucherInfo.bizUnitCode))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.scrapVoucherInfo.costCenterCode || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.scrapVoucherInfo.prftCenterCode || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(11),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.scrapVoucherInfo.createTime))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(12),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.scrapVoucherInfo.applyTime))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(13),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.scrapVoucherInfo.ledgerTime || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.showBizUnitWarehouse
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(14),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.scrapVoucherInfo.warehouseName))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(15),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.scrapVoucherInfo.applyDesc || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(16),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.scrapVoucherInfo.digest || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(17),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.scrapVoucherInfo.autoMaskAsIdle ? "是" : "否")
                    )
                  ])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("资产信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showDeviceItemFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowDeviceItem()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showDeviceItemFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showDeviceItemFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showDeviceItemFlag
        ? [
            _c(
              "div",
              { staticClass: "table-layout" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.scrapItems,
                      maxHeight: "500",
                      border: "",
                      "tooltip-effect": "dark"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "innerCode",
                        "min-width": "180",
                        fixed: "",
                        label: "资产编号",
                        "show-overflow-tooltip": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "table-cell-link",
                                  on: {
                                    click: function($event) {
                                      _vm.viewAssetInfo(
                                        rows.row,
                                        rows.row.innerCode
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(rows.row.innerCode))]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "title",
                        label: "资产描述全称",
                        width: "180",
                        fixed: "",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "quantity",
                        width: "100",
                        label: "报废数量"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "splitible",
                        width: "100",
                        label: "控制方式"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    rows.row.splitible ? "按金额" : "按数量"
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "资产原值(元)",
                        width: "80",
                        align: "right"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.orgWorthKz != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.orgWorthKz.toFixed(2))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "资产净值(元)",
                        width: "80",
                        align: "right"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.netWorthKz != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.netWorthKz.toFixed(2))
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "报废原值(元)",
                        width: "80",
                        align: "right"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.orgWorth != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.orgWorth.toFixed(2)))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        width: "80",
                        label: "报废金额(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.netWorth != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.netWorth.toFixed(2)))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "durableLife",
                        width: "100",
                        label: "使用年限(月)"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "fiscalInTime",
                        label: "入账时间",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.fiscalInTime != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.fiscalInTime))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "scrapCause",
                        "min-width": "150",
                        label: "报废原因"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.devcScrapCauseMap[rows.row.scrapCause]
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "innerNo",
                        label: "外部资产编码",
                        width: "180",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "staffName",
                        width: "120",
                        label: "报废人员"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "comFullName",
                        width: "200",
                        label: "部门全称",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "costCenterCode",
                        label: "成本中心",
                        width: "120",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "departName",
                        width: "180",
                        label: "报废部门",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "fixedSpec",
                        label: "规格",
                        width: "180",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "assetNature",
                        label: "资产属性",
                        width: "100",
                        "show-overflow-tooltip": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.assetNature != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.assetNatureMap[rows.row.assetNature]
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "durableYears",
                        width: "100",
                        label: "已用年限(月)"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "deprTiming",
                        width: "100",
                        label: "报废时效类型"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.deprTiming != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.scrapDeprTimingMap[
                                          rows.row.deprTiming
                                        ]
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "tmpNo",
                        "min-width": "250",
                        label: "系统编号",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "assetType",
                        width: "100",
                        label: "管理方式",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.assetTypeMap[rows.row.assetType])
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.devcCustTag1.enabled == true
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "devcCustTag1Val",
                            label: _vm.devcCustTag1.dispName,
                            width: "120"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.devcCustTag2.enabled == true
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "devcCustTag2Val",
                            label: _vm.devcCustTag2.dispName,
                            width: "120"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.devcCustTag3.enabled == true
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "devcCustTag3Val",
                            label: _vm.devcCustTag3.dispName,
                            width: "120"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "theInc",
                        width: "150",
                        label: "清理收入",
                        align: "right"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.theInc != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.theInc.toFixed(2)))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.colNames, function(colNameX) {
                      return [
                        _c("el-table-column", {
                          attrs: {
                            label: colNameX,
                            align: "center",
                            width: "200",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._l(scope.row.reservedNoJson, function(
                                    theJson
                                  ) {
                                    return scope.row.reservedNoJson != null
                                      ? [
                                          theJson.text == colNameX
                                            ? _c("span", [
                                                _vm._v(_vm._s(theJson.value))
                                              ])
                                            : _vm._e()
                                        ]
                                      : _vm._e()
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ]
                    })
                  ],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pagination-layout" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    "page-size": _vm.pageSize,
                    "page-sizes": _vm.pageSizes,
                    "current-page": _vm.pageNumber,
                    total: _vm.totalCount,
                    layout: "total, sizes, prev, pager, next, jumper"
                  },
                  on: {
                    "current-change": _vm.handlePageChange,
                    "size-change": _vm.handleSizeChange
                  }
                })
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.scrapVoucherInfo.scrapFileList != null &&
      _vm.scrapVoucherInfo.scrapFileList.length > 0
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("附件信息")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "shrink-tab fr",
                class: _vm.showFileItemInfoFlag ? "current" : "",
                on: {
                  click: function($event) {
                    _vm.doShowFileItemInfo()
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.showFileItemInfoFlag ? "隐藏" : "展开"))
                ]),
                _vm._v(" "),
                _c("i", {
                  class: _vm.showFileItemInfoFlag
                    ? "el-icon-arrow-down"
                    : "el-icon-arrow-right"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showFileItemInfoFlag
        ? [
            _vm.scrapVoucherInfo.scrapFileList != null &&
            _vm.scrapVoucherInfo.scrapFileList.length > 0
              ? _c(
                  "div",
                  { staticClass: "file-view-list" },
                  [
                    _vm._m(18),
                    _vm._v(" "),
                    _vm._l(_vm.scrapVoucherInfo.scrapFileList, function(
                      fileInfo,
                      index
                    ) {
                      return [
                        _c("swb-file-item-li", {
                          attrs: {
                            trackKey: index,
                            fileName: fileInfo.name,
                            fileBrowseUrl: fileInfo.fileBrowseUrl,
                            fileDownloadUrl: fileInfo.fileBrowseUrl,
                            fileUuid: fileInfo.fileUuid,
                            deletable: false
                          }
                        })
                      ]
                    })
                  ],
                  2
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.scrapVoucherInfo.outerAuditFlag
        ? [
            _c("div", { staticClass: "content-caption dashed" }, [
              _c("span", [_vm._v("审核记录")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "shrink-tab fr",
                  class: _vm.showOaAuditRecFlag ? "current" : "",
                  on: {
                    click: function($event) {
                      _vm.doShowOaAuditRec()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.showOaAuditRecFlag ? "隐藏" : "展开"))
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    class: _vm.showOaAuditRecFlag
                      ? "el-icon-arrow-down"
                      : "el-icon-arrow-right"
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm.showOaAuditRecFlag
              ? [
                  _c("swb-oa-audit-rec-list", {
                    ref: "swb_oa_audit_rec_list",
                    attrs: {
                      bizTypeCode: "retailer.assets.scrap",
                      bizVoucherNo: _vm.scrapVoucherInfo.innerNo,
                      auditSeqNo: _vm.scrapVoucherInfo.auditSeqNo
                    }
                  })
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.scrapVoucherInfo.outerAuditFlag && _vm.scrapVoucherInfo.no != null
        ? [
            _c("div", { staticClass: "content-caption dashed" }, [
              _c("span", [_vm._v("审核记录")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "shrink-tab fr",
                  class: _vm.showShopDeviceActFlag ? "current" : "",
                  on: {
                    click: function($event) {
                      _vm.doShowShopDeviceAct()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.showShopDeviceActFlag ? "隐藏" : "展开"))
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    class: _vm.showShopDeviceActFlag
                      ? "el-icon-arrow-down"
                      : "el-icon-arrow-right"
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm.showShopDeviceActFlag
              ? [
                  _c("swb-shop-device-act-rec-list", {
                    ref: "swb_shop_device_act_rec_list",
                    attrs: {
                      showQuery: false,
                      showComFlag: false,
                      srcVoucherNo: _vm.scrapVoucherInfo.no,
                      srcVoucherType: _vm.srcVoucherType
                    }
                  })
                ]
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("报废单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("记账凭证号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("报废总数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("报废金额")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请人电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("所属公司")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("所属机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("成本中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("利润中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("生凭时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("报废仓库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("自动标记闲置")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-view-header" }, [
      _c("div", { staticClass: "file-name" }, [_vm._v("名称")]),
      _vm._v(" "),
      _c("div", { staticClass: "file-opera" }, [_vm._v("操作")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5478500a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5478500a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/scrapVoucher/ShopDeviceScrapVoucherView.vue
// module id = 2570
// module chunks = 0